/* eslint-disable react/prop-types */
import React, { useEffect, useMemo } from 'react';

import Autocomplete from '../../../../../../shared/ui/Autocomplete/Autocomplete';
import { useLazyGetAppUserResourceQuery } from '../../../../../../entities/account/appUsersResource/redux/appUsersResource.api';

function AppUsersAutocomplete({ label, value, initialAppUserId, id, onChange, companyId }) {
  const [getUsers, users] = useLazyGetAppUserResourceQuery();

  useEffect(() => {
    getUsers({
      params: {
        'companyId.equals': companyId,
      },
    });
  }, [getUsers, companyId]);

  const values = useMemo(
    () =>
      users?.data?.data?.map((item, i) => ({
        id: i,
        appUserId: item.appUserId,
        name: `${item.firstName || ''} ${item.lastName || ''}`.trim() || 'Имя не указано',
      })) || [],
    [users?.data],
  );

  const currentValue = useMemo(() => {
    if (!initialAppUserId || value?.appUserId || value === null) return value || null;

    const appUserId = Number(initialAppUserId);
    return values.find((user) => user.appUserId === appUserId) || value || null;
  }, [initialAppUserId, values, value]);

  return (
    <Autocomplete
      id={id}
      label={label}
      value={currentValue}
      values={values}
      loading={users?.isLoading}
      onChange={onChange}
    />
  );
}

export default AppUsersAutocomplete;
